import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { AuthService } from '../user-management/auth.service';

const PUBLIC_TOKEN_URL = 'generate-public-token';
const AUTH_HEADER_KEY = 'Authorization';

export const requestHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) return next(req);

  const isPublicTokenRequest = req.url.includes(PUBLIC_TOKEN_URL);

  // Solo leer localStorage; no inyectar SessionService para evitar bucle (efectos/signal en medio de la petición)
  const apiKey = isPublicTokenRequest
    ? localStorage.getItem(AuthService.PUBLIC_TOKEN_KEY)
    : (localStorage.getItem(AUTH_HEADER_KEY) ?? localStorage.getItem(AuthService.PUBLIC_TOKEN_KEY));

  if (apiKey) {
    return next(
      req.clone({
        setHeaders: { Authorization: `Bearer ${apiKey}` },
      })
    );
  }
  return next(req);
};
